import { useEffect, useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import "./WesTemplateNew1.css";
import { toast } from "react-toastify";
import AbstractModalHeader from "react-bootstrap/esm/AbstractModalHeader";
import { formatGermanFixedBy2 } from "../../../utility/NumberFormat";

const WesTemplateNew1 = (props) => {
  const {
    hdrValue,
    onDataChange,
    singleData,
    resetFlag,
    templateWesNewPart,
    setTemplateWesNewPart,
  } = props;
  // console.log("singleData >>>wes", singleData?.partP?.find((item) => item?.typId === "KOLL"));

  // console.log("templateWesNewPart", templateWesNewPart)

  const initialInputsState = {
    inputFirst: "",
    inputSecond: "",
    vororder1: "",
    nachorder1: "",
    vororder2: "",
    nachorder2: "",
  };

  const initialWesFirstValue = {
    kollSumTotalPct: "", //  kollSumTotalPct
    nosSumTotalPct: "",
    kollSumVororderPct: "",
    nosSumVororderPct: "",
    kollSumNachorderPct: "",
    nosSumNachorderPct: "",

    kollektionAbschriftProzentual: "",
    nosAbschriftProzentual: "",
    kollektionEkAufschlag: "",
    kollektionEkAbschlag: "",
    nosEkAufschlag: "",
    nosEkAbschlag: "",

    kollektionAbschriftProzentual: "",
    kollektionEkAufschlag: "",
    kollektionEkAbschlag: "",

    nosAbschriftProzentual: "",
    nosEkAufschlag: "",
    nosEkAbschlag: "",
  };

  const [inputs, setInputs] = useState(initialInputsState);
  const [wesFirstValue, setWesFirstValue] = useState(initialWesFirstValue);

  // useEffect(() => {
  //   if (hdrValue) {
  //     const updatedState = {
  //       ...wesFirstValue,
  //       kollSumTotalPct: wesFirstValue.inputFirst,
  //       nosSumTotalPct: wesFirstValue.nosSumTotalPct,
  //       kollSumVororderPct: wesFirstValue.kollSumVororderPct,
  //       kollSumNachorderPct: wesFirstValue.kollSumNachorderPct,
  //       nosSumVororderPct: wesFirstValue.nosSumVororderPct,
  //       nosSumNachorderPct: wesFirstValue.nosSumNachorderPct,
  //     };

  //     setWesFirstValue(updatedState);

  //     // 🔹 Parent ko updated data bhejo
  //     if (onDataChange) {
  //       onDataChange(updatedState);
  //     }
  //   }
  // }, [hdrValue]);

  // Api filed data

  useEffect(() => {
    if (!singleData) return;

    // =========================
    // partP Data
    // =========================
    const kollData = Array.isArray(singleData?.partP)
      ? singleData.partP.find((item) => item?.typId === "KOLL")
      : null;

    const nosData = Array.isArray(singleData?.partP)
      ? singleData.partP.find((item) => item?.typId === "NOS")
      : null;

    // console.log("kollData >>>", kollData);
    // console.log("nosData >>>", nosData);

    setTemplateWesNewPart((prev) => ({
      ...prev,

      koll: [
        {
          ...prev.koll?.[0],

          percValue: kollData?.percValue,
          prePerc: kollData?.prePerc,
          rePerct: 100 - kollData?.prePerc || "",
          percred: kollData?.percred,
          estimatedCalc: kollData?.estimatedCalc,
          estimatedCalcDisc: kollData?.estimatedCalcDisc,
          outgoingCalc: kollData?.outgoingCalc,
          outgoingCalcDisc: kollData?.outgoingCalcDisc,
          lugPlan: kollData?.lugPlan,
          delivQuota: kollData?.delivQuota,
          rePerct: kollData?.rePerct,
        },
      ],

      Nos: [
        {
          ...prev.Nos?.[0],

          percValue: nosData?.percValue,
          prePerc: nosData?.prePerc,
          rePerct: 100 - nosData?.prePerc || "",
          percred: nosData?.percred,
          estimatedCalc: nosData?.estimatedCalc,
          estimatedCalcDisc: nosData?.estimatedCalcDisc,
          outgoingCalc: nosData?.outgoingCalc,
          outgoingCalcDisc: nosData?.outgoingCalcDisc,
          lugPlan: nosData?.lugPlan,
          delivQuota: nosData?.delivQuota,
          rePerct: nosData?.rePerct,
        },
      ],
    }));

    // =========================
    // wes Data
    // =========================
    if (singleData?.wes) {
      const updatedState = {
        ...wesFirstValue,

        kollSumTotalPct: singleData?.wes?.kollSumTotalPct || 0,
        nosSumTotalPct: singleData?.wes?.nosSumTotalPct || 0,
        kollSumVororderPct: singleData?.wes?.kollSumVororderPct || 0,
        kollSumNachorderPct: singleData?.wes?.kollSumNachorderPct || 0,
        nosSumVororderPct: singleData?.wes?.nosSumVororderPct || 0,
        nosSumNachorderPct: singleData?.wes?.nosSumNachorderPct || 0,

        kollektionAbschriftProzentual:
          singleData?.wes?.kollektionAbschriftProzentual || 0,
        kollektionEkAufschlag: singleData?.wes?.kollektionEkAufschlag || 0,
        kollektionEkAbschlag: singleData?.wes?.kollektionEkAbschlag || 0,

        nosAbschriftProzentual: singleData?.wes?.nosAbschriftProzentual || 0,
        nosEkAufschlag: singleData?.wes?.nosEkAufschlag || 0,
        nosEkAbschlag: singleData?.wes?.nosEkAbschlag || 0,
      };

      setWesFirstValue(updatedState);
      onDataChange?.(updatedState);
    }
  }, [singleData]);

  //Total

  // const kollData = singleData?.partP?.find(
  //   (item) => item.typId === "KOLL"
  // );

  // console.log("kollData", kollData)
  // const nosData = singleData?.partP?.find(
  //   (item) => item.typId === "NOS"
  // );

  // reset value
  useEffect(() => {
    if (resetFlag) {
      setInputs(initialInputsState);
      setWesFirstValue(initialWesFirstValue);
      setTemplateWesNewPart({}); // reset new variable name
    }
  }, [resetFlag]);

  const calculatePARTP = (prev, newState) => {};

  const handleInputChange = (e, type) => {
    const { name, value } = e.target;

    let cleanedValue = value.replace(".", ",");

    if (cleanedValue.startsWith(",")) {
      cleanedValue = "0" + cleanedValue;
    }

    // const isValid = /^\d{0,3}(,\d{0,1})?$/.test(cleanedValue);
    const freeFields = [
      "percred",
      "estimatedCalc",
      "estimatedCalcDisc",
      "outgoingCalc",
      "outgoingCalcDisc",
      "lugPlan",
      "delivQuota",
    ];

    const isValid = freeFields.includes(name)
      ? /^\d*(,\d{0,1})?$/.test(cleanedValue)
      : /^\d{0,3}(,\d{0,1})?$/.test(cleanedValue);

    if (!isValid) return;

    const pairs = {
      kollSumTotalPct: "nosSumTotalPct",
      nosSumTotalPct: "kollSumTotalPct",
      kollSumVororderPct: "kollSumNachorderPct",
      kollSumNachorderPct: "kollSumVororderPct",
      nosSumVororderPct: "nosSumNachorderPct",
      nosSumNachorderPct: "nosSumVororderPct",
    };

    const otherName = pairs[name];

    let numericValue = parseFloat(cleanedValue.replace(",", "."));

    if (isNaN(numericValue)) numericValue = 0;

    const remainingValue = 100 - numericValue; // new line

    // if (numericValue > 100) numericValue = 100;
    // if (numericValue < 0) numericValue = 0;

    if (!freeFields.includes(name)) {
      if (numericValue > 100) numericValue = 100;
      if (numericValue < 0) numericValue = 0;
    }

    // setInputs((prev) => {
    //   const updated = { ...prev };

    //   updated[name] = cleanedValue;

    //   if (otherName) {
    //     updated[otherName] = String(100 - numericValue).replace(".", ",");
    //   }

    //   return updated;
    // });

    // // store STRING while typing
    // setWesFirstValue((prev) => {
    //   const updated = {
    //     ...prev,
    //     [name]: cleanedValue,
    //   };

    //   if (otherName) {
    //     updated[otherName] = String(100 - numericValue).replace(".", ",");
    //   }

    //   props.onDataChange?.(updated);

    //   return updated;
    // });

    // new
    setTemplateWesNewPart((prev) => {
      const updated = { ...prev };

      // Pair 1 : Koll percValue <-> Nos percValue
      if (name === "percValue") {
        if (type === "koll") {
          updated.koll = [
            {
              ...prev.koll?.[0],
              percValue: cleanedValue,
            },
          ];

          updated.Nos = [
            {
              ...prev.Nos?.[0],
              percValue: remainingValue,
            },
          ];
        }

        if (type === "nos") {
          updated.Nos = [
            {
              ...prev.Nos?.[0],
              percValue: cleanedValue,
            },
          ];

          updated.koll = [
            {
              ...prev.koll?.[0],
              percValue: remainingValue,
            },
          ];
        }
      }

      // Pair 2 : Koll prePerc <-> rePerct
      if (name === "prePerc" && type === "koll") {
        updated.koll = [
          {
            ...prev.koll?.[0],
            prePerc: cleanedValue,
            rePerct: remainingValue,
          },
        ];
      }

      // Pair 2 Reverse : Koll rePerct <-> prePerc
      if (name === "rePerct" && type === "koll") {
        updated.koll = [
          {
            ...prev.koll?.[0],
            rePerct: cleanedValue,
            prePerc: remainingValue,
          },
        ];
      }
      // Pair 3 Reverse : Nos rePerct <-> prePerc
      if (name === "rePerct" && type === "nos") {
        updated.Nos = [
          {
            ...prev.Nos?.[0],
            rePerct: cleanedValue,
            prePerc: String(remainingValue).replace(".", ","),
          },
        ];
      }

      // Pair 3 : Nos prePerc <-> rePerct
      if (name === "prePerc" && type === "nos") {
        updated.Nos = [
          {
            ...prev.Nos?.[0],
            prePerc: cleanedValue,
            rePerct: remainingValue,
          },
        ];
      }

      //
      // Direct Save Fields
      if (
        [
          "percred",
          "estimatedCalc",
          "estimatedCalcDisc",
          "lugPlan",
          "delivQuota",
        ].includes(name)
      ) {
        const current =
          type === "koll"
            ? { ...prev.koll?.[0], [name]: cleanedValue }
            : { ...prev.Nos?.[0], [name]: cleanedValue };

        // current.outgoingCalc =
        //   ((parseFloat(current.estimatedCalc || 0) + 100) *
        //     (100 - parseFloat(current.percred || 0))) /
        //     100 -
        //   100;

        //   const percred = parseFloat(current?.percred || 0);
        //   const estimatedCalcDisc = parseFloat(current?.estimatedCalcDisc || 0);

        //   current.outgoingCalcDisc =
        //     (((100 * (100 - percred)) / 100 - (100 - estimatedCalcDisc)) /
        //       (100 - percred)) *
        //     100;

        const percred = current?.percred;
        const estimatedCalcDisc = current?.estimatedCalcDisc;

        current.outgoingCalcDisc =
          ((100 + percred) / 100) * estimatedCalcDisc - percred;

        current.outgoingCalc =
          (current.outgoingCalcDisc * 100) / (100 - current.outgoingCalcDisc);

        if (type === "koll") {
          updated.koll = [current];
        } else {
          updated.Nos = [current];
        }
      }

      return updated;
    });
  };

  const handleBlurInputChange = (e, type) => {
    const { name, value } = e.target;

    // const pairs = {
    //   inputFirst: "inputSecond",
    //   inputSecond: "inputFirst",
    //   vororder1: "nachorder1",
    //   nachorder1: "vororder1",
    //   vororder2: "nachorder2",
    //   nachorder2: "vororder2",
    // };

    // const pairs = {
    //   kollSumTotalPct: "nosSumTotalPct",
    //   nosSumTotalPct: "kollSumTotalPct",
    //   kollSumVororderPct: "kollSumNachorderPct",
    //   kollSumNachorderPct: "kollSumVororderPct",
    //   nosSumVororderPct: "nosSumNachorderPct",
    //   nosSumNachorderPct: "nosSumVororderPct",
    // };

    const pairs = {
      kollSumTotalPct: "nosSumTotalPct",
      nosSumTotalPct: "kollSumTotalPct",
      kollSumVororderPct: "kollSumNachorderPct",
      kollSumNachorderPct: "kollSumVororderPct",
      nosSumVororderPct: "nosSumNachorderPct",
      nosSumNachorderPct: "nosSumVororderPct",
    };

    const otherName = pairs[name];
    // console.log("value on blue ", value)

    let numericValue = parseFloat(value.replace(",", "."));

    // value remove then not show 0,0
    if (
      ["percred", "estimatedCalc", "estimatedCalcDisc"].includes(name) &&
      value.trim() === ""
    ) {
      numericValue = "";
    } else if (isNaN(numericValue)) {
      numericValue = 0;
    }

    if (isNaN(numericValue)) numericValue = 0;

    // if (numericValue > 100) numericValue = 100;
    // if (numericValue < 0) numericValue = 0;
    const freeFields = [
      "percred",
      "estimatedCalc",
      "estimatedCalcDisc",
      "outgoingCalc",
      "outgoingCalcDisc",
      "lugPlan",
      "delivQuota",
    ];
    if (!freeFields.includes(name)) {
      if (numericValue > 100) numericValue = 100;
      if (numericValue < 0) numericValue = 0;
    }

    const remainingValue = 100 - numericValue; // new line

    // store NUMBER on blur
    // setWesFirstValue((prev) => {
    //   const updated = {
    //     ...prev,
    //     [name]: numericValue,
    //   };

    //   if (otherName) {
    //     updated[otherName] = 100 - numericValue;
    //   }

    //   props.onDataChange?.(updated);

    //   return updated;
    // });

    // Template State
    setTemplateWesNewPart((prev) => {
      const updated = { ...prev };

      // Pair 1 : Koll percValue <-> Nos percValue
      if (name === "percValue") {
        if (type === "koll") {
          updated.koll = [
            {
              ...prev.koll?.[0],
              percValue: numericValue,
            },
          ];

          updated.Nos = [
            {
              ...prev.Nos?.[0],
              percValue: remainingValue,
            },
          ];
        }

        if (type === "nos") {
          updated.Nos = [
            {
              ...prev.Nos?.[0],
              percValue: numericValue,
            },
          ];

          updated.koll = [
            {
              ...prev.koll?.[0],
              percValue: remainingValue,
            },
          ];
        }
      }

      // Pair 2 : Koll prePerc <-> rePerct
      if (name === "prePerc" && type === "koll") {
        updated.koll = [
          {
            ...prev.koll?.[0],
            prePerc: numericValue,
            rePerct: remainingValue,
          },
        ];
      }

      // Pair 2 Reverse : Koll rePerct <-> prePerc
      if (name === "rePerct" && type === "koll") {
        updated.koll = [
          {
            ...prev.koll?.[0],
            rePerct: numericValue,
            prePerc: remainingValue,
          },
        ];
      }

      // Pair 3 Reverse : Nos rePerct <-> prePerc
      if (name === "rePerct" && type === "nos") {
        updated.Nos = [
          {
            ...prev.Nos?.[0],
            rePerct: numericValue,
            prePerc: remainingValue,
          },
        ];
      }

      // Pair 3 : Nos prePerc <-> rePerct
      if (name === "prePerc" && type === "nos") {
        updated.Nos = [
          {
            ...prev.Nos?.[0],
            prePerc: numericValue,
            rePerct: remainingValue,
          },
        ];
      }

      // Pair 4 : Koll percred
      if (
        [
          "percred",
          "estimatedCalc",
          "estimatedCalcDisc",
          "lugPlan",
          "delivQuota",
        ].includes(name)
      ) {
        const finalValue = value.trim() === "" ? 0 : numericValue;

        const current =
          type === "koll"
            ? { ...prev.koll?.[0], [name]: finalValue }
            : { ...prev.Nos?.[0], [name]: finalValue };

        // current.outgoingCalc =
        //   ((parseFloat(current?.estimatedCalc || 0) + 100) *
        //     (100 - parseFloat(current?.percred || 0))) /
        //     100 -
        //   100;

        // const percred = parseFloat(current?.percred || 0);
        // const estimatedCalcDisc = parseFloat(current?.estimatedCalcDisc || 0);

        // current.outgoingCalcDisc =
        //   (((100 * (100 - percred)) / 100 - (100 - estimatedCalcDisc)) /
        //     (100 - percred)) *
        //   100;

        const percred = current?.percred;
        const estimatedCalcDisc = current?.estimatedCalcDisc;

        current.outgoingCalcDisc =
          ((100 + percred) / 100) * estimatedCalcDisc - percred;

        current.outgoingCalc =
          (current.outgoingCalcDisc * 100) / (100 - current.outgoingCalcDisc);

        if (type === "koll") {
          updated.koll = [current];
        } else {
          updated.Nos = [current];
        }
      }

      return updated;
    });
  };

  console.log("templatenew part from wes?", templateWesNewPart);
  //  Vororder Total
  const VororderTotal =
    parseFloat(templateWesNewPart?.koll?.[0]?.prePerc || 0) +
    parseFloat(templateWesNewPart?.Nos?.[0]?.prePerc || 0);

  // Nachorder Total
  const kollPrePerc = templateWesNewPart?.koll?.[0]?.prePerc;
  const nosPrePerc = templateWesNewPart?.Nos?.[0]?.prePerc;

  const NachorderTotal =
    (kollPrePerc == null || kollPrePerc === "") &&
    (nosPrePerc == null || nosPrePerc === "")
      ? ""
      : 100 -
        parseFloat(kollPrePerc || 0) +
        (100 - parseFloat(nosPrePerc || 0));

  // console.log("nosData.rePerct",nosData.rePerct)
  // console.log("NachorderTotal",NachorderTotal)

  // Abschrift Prozentual Total
  const abschriftTotal =
    (parseFloat(templateWesNewPart?.koll?.[0]?.percred || 0) +
      parseFloat(templateWesNewPart?.Nos?.[0]?.percred || 0)) /
    2;

  // Eingang Aufschlag Total
  const avgEingangAufschlagTotal =
    (parseFloat(templateWesNewPart?.koll?.[0]?.estimatedCalc || 0) +
      parseFloat(templateWesNewPart?.Nos?.[0]?.estimatedCalc || 0)) /
    2;
  const eingangAufschlagTotal =
    ((avgEingangAufschlagTotal + 100) / 100) * 100 - 100;

  // Eingang Abschlag Total
  const avgEingangAbschlagTotal =
    (parseFloat(templateWesNewPart?.koll?.[0]?.estimatedCalcDisc || 0) +
      parseFloat(templateWesNewPart?.Nos?.[0]?.estimatedCalcDisc || 0)) /
    2;

  const eingangAbschlagTotal =
    100 - ((100 - avgEingangAbschlagTotal) * 100) / 100;

  const eingAufschlagTotal =
    (parseFloat(templateWesNewPart?.koll?.[0]?.outgoingCalc || 0) +
      parseFloat(templateWesNewPart?.Nos?.[0]?.outgoingCalc || 0)) /
    2;

  // const eingAufschlagTotal =
  //   (((avgEingangAufschlagTotal + 100) * (100 - abschriftTotal)) / 100 / 100) *
  //     100 -
  //   100;

  const nachEingAbschlagTotal =
    (parseFloat(templateWesNewPart?.koll?.[0]?.outgoingCalcDisc || 0) +
      parseFloat(templateWesNewPart?.Nos?.[0]?.outgoingCalcDisc || 0)) /
    2;

  // const nachEingAbschlagTotal =
  //   100 - ((100 - avgNachEingAbschlagTotal) * (100)) / 100;

  const lugTotal =
    (parseFloat(templateWesNewPart?.koll?.[0]?.lugPlan || 0) +
      parseFloat(templateWesNewPart?.Nos?.[0]?.lugPlan || 0)) /
    2;

  const auslieferungsquoteTotal =
    (parseFloat(templateWesNewPart?.koll?.[0]?.delivQuota || 0) +
      parseFloat(templateWesNewPart?.Nos?.[0]?.delivQuota || 0)) /
    2;

  return (
    <div className="p-2 border rounded bg-white">
      <Table
        bordered
        hover
        responsive
        size="sm"
        className="wes-table1 align-middle text-center"
      >
        <thead className="table-warning text-center align-middle">
          <tr>
            <th colSpan="2"></th>
            <th colSpan="1">Vororder</th>
            <th colSpan="1">Nachorder</th>

            <th colSpan="1"></th>

            <th colSpan="6">Nachorder</th>

            {/* <th colSpan="2"></th> */}
          </tr>

          <tr>
            <th rowSpan="2">Wareneingang</th>
            <th rowSpan="2">%</th>

            <th rowSpan="2">%</th>

            <th rowSpan="2">%</th>

            <th rowSpan="2">
              Abschrift
              <br />
              prozentual
            </th>

            <th colSpan="2">Eingangskalkulation</th>

            <th colSpan="2">Ausgangskalkulation</th>

            <th rowSpan="2">LUG</th>

            <th rowSpan="2">
              Auslieferungs
              <br />
              quote
            </th>
          </tr>

          <tr>
            <th>Aufschlag</th>
            <th>Abschlag</th>

            <th>Aufschlag</th>
            <th>Abschlag</th>
          </tr>
        </thead>

        <tbody>
          {/* Row 1 */}
          <tr>
            <td
              style={{
                background: "rgb(247, 246, 215)",
              }}
            >
              Kollektion
            </td>
            <td>
              <input
                className="form-control form-control-sm text-center"
                name="percValue" //  Koll percValue
                style={{ width: "60px" }}
                // value={formatGermanFixedBy2(wesFirstValue.kollSumTotalPct)}
                value={formatGermanFixedBy2(
                  templateWesNewPart?.koll?.[0]?.percValue
                )}
                // onChange={handleInputChange}
                onChange={(e) => handleInputChange(e, "koll")}
                onBlur={(e) => handleBlurInputChange(e, "koll")}
                // onBlur={handleBlurInputChange}
                autoComplete="off"
              />
            </td>
            <td>
              <input
                className="form-control form-control-sm text-center"
                name="prePerc" // Koll prePerc
                // value={formatGermanFixedBy2(wesFirstValue.kollSumVororderPct)}
                value={formatGermanFixedBy2(
                  templateWesNewPart?.koll?.[0]?.prePerc
                )}
                // onChange={handleInputChange}
                onChange={(e) => handleInputChange(e, "koll")}
                onBlur={(e) => handleBlurInputChange(e, "koll")}
                // onBlur={handleBlurInputChange}
                autoComplete="off"
              />
            </td>
            <td
              style={{
                background: "rgb(247, 246, 215)",
              }}
            >
              <input
                className="form-control form-control-sm text-center"
                style={{
                  background: "rgb(247, 246, 215)",
                }}
                // value={59.2}
                name="rePerct" // koll rePerct
                value={formatGermanFixedBy2(
                  templateWesNewPart?.koll?.[0]?.rePerct
                )}
                // value={formatGermanFixedBy2(
                //   100 - Number(templateWesNewPart?.koll?.[0]?.prePerc || 0)
                // )}
                // onChange={handleInputChange}
                // onBlur={handleBlurInputChange}
                onChange={(e) => handleInputChange(e, "koll")}
                onBlur={(e) => handleBlurInputChange(e, "koll")}
                autoComplete="off"
                disabled
              />
            </td>
            <td>
              <input
                name="percred" // Koll percred
                className="form-control form-control-sm text-center"
                // value={"59,1"}
                // value={formatGermanFixedBy2(wesFirstValue?.kollektionAbschriftProzentual,)}
                value={formatGermanFixedBy2(
                  templateWesNewPart?.koll?.[0]?.percred
                )}
                autoComplete="off"
                // onChange={handleWes1Value}
                // onBlur={handleBlurWes1Value}
                onChange={(e) => handleInputChange(e, "koll")}
                onBlur={(e) => handleBlurInputChange(e, "koll")}
                maxLength={6}
              />
            </td>
            <td>
              <input
                name="estimatedCalc" // Koll estimatedCalc
                className="form-control form-control-sm text-center"
                // defaultValue={"145,5"}
                // value={formatGermanFixedBy2(wesFirstValue?.kollektionEkAufschlag,)}
                value={formatGermanFixedBy2(
                  templateWesNewPart?.koll?.[0]?.estimatedCalc
                )}
                autoComplete="off"
                // onChange={handleWes1Value}
                // onBlur={handleBlurWes1Value}
                onChange={(e) => handleInputChange(e, "koll")}
                onBlur={(e) => handleBlurInputChange(e, "koll")}
                maxLength={6}
              />
            </td>
            <td>
              <input
                name="estimatedCalcDisc" //  Koll estimatedCalcDisc
                className="form-control form-control-sm text-center"
                // value={"59,2"}
                // value={formatGermanFixedBy2(wesFirstValue?.kollektionEkAbschlag)}
                value={formatGermanFixedBy2(
                  templateWesNewPart?.koll?.[0]?.estimatedCalcDisc
                )}
                autoComplete="off"
                // onChange={handleWes1Value}
                // onBlur={handleBlurWes1Value}
                onChange={(e) => handleInputChange(e, "koll")}
                onBlur={(e) => handleBlurInputChange(e, "koll")}
                maxLength={6}
              />
            </td>
            {/* new */}
            <td
              style={{
                background: "rgb(247, 246, 215)",
              }}
            >
              <input
                name="outgoingCalc" //  Koll outgoingCalc
                className="form-control form-control-sm text-center"
                style={{
                  background: "rgb(247, 246, 215)",
                }}
                // value={formatGermanFixedBy2(wesFirstValue?.kollektionEkAbschlag)}
                value={formatGermanFixedBy2(
                  templateWesNewPart?.koll?.[0]?.outgoingCalc
                )}
                autoComplete="off"
                // onChange={handleWes1Value}
                // onBlur={handleBlurWes1Value}
                // onChange={(e) => handleInputChange(e, "koll")}
                // onBlur={(e) => handleBlurInputChange(e, "koll")}
                maxLength={6}
                disabled
              />
            </td>
            <td
              style={{
                background: "rgb(247, 246, 215)",
              }}
            >
              <input
                name="outgoingCalcDisc" //  Koll outgoingCalcDisc
                className="form-control form-control-sm text-center"
                style={{
                  background: "rgb(247, 246, 215)",
                }}
                // value={formatGermanFixedBy2(wesFirstValue?.kollektionEkAbschlag)}
                value={formatGermanFixedBy2(
                  templateWesNewPart?.koll?.[0]?.outgoingCalcDisc
                )}
                autoComplete="off"
                // onChange={handleWes1Value}
                // onBlur={handleBlurWes1Value}
                // onChange={(e) => handleInputChange(e, "koll")}
                // onBlur={(e) => handleBlurInputChange(e, "koll")}
                maxLength={6}
                disabled
              />
            </td>
            <td>
              <input
                name="lugPlan" //  Koll lugPlan
                className="form-control form-control-sm text-center"
                style={{ width: "60px" }}
                // value={"59"}
                // value={formatGermanFixedBy2(wesFirstValue?.kollektionEkAbschlag)}
                value={formatGermanFixedBy2(
                  templateWesNewPart?.koll?.[0]?.lugPlan
                )}
                autoComplete="off"
                // onChange={handleWes1Value}
                // onBlur={handleBlurWes1Value}
                onChange={(e) => handleInputChange(e, "koll")}
                onBlur={(e) => handleBlurInputChange(e, "koll")}
                maxLength={6}
              />
            </td>
            <td>
              <input
                name="delivQuota" //  Koll delivQuota
                className="form-control form-control-sm text-center"
                // value={"60"}
                // value={formatGermanFixedBy2(wesFirstValue?.kollektionEkAbschlag)}
                value={formatGermanFixedBy2(
                  templateWesNewPart?.koll?.[0]?.delivQuota
                )}
                autoComplete="off"
                // onChange={handleWes1Value}
                // onBlur={handleBlurWes1Value}
                onChange={(e) => handleInputChange(e, "koll")}
                onBlur={(e) => handleBlurInputChange(e, "koll")}
                maxLength={6}
              />
            </td>
          </tr>

          {/* Row 2 */}
          <tr>
            <td
              style={{
                background: "rgb(247, 246, 215)",
              }}
            >
              NOS
            </td>
            <td
              style={{
                background: "rgb(212, 236, 251)",
              }}
            >
              <input
                className="form-control form-control-sm text-center"
                name="percValue" // NOS percValue
                // value={formatGermanFixedBy2(wesFirstValue.nosSumTotalPct)}
                value={formatGermanFixedBy2(
                  templateWesNewPart?.Nos?.[0]?.percValue
                )}
                // onChange={handleInputChange}
                onChange={(e) => handleInputChange(e, "nos")}
                onBlur={(e) => handleBlurInputChange(e, "nos")}
                // onBlur={handleBlurInputChange}
                autoComplete="off"
                style={{
                  background: "rgb(212, 236, 251)",
                  width: "60px",
                }}
              />
            </td>
            <td
              style={{
                background: "rgb(212, 236, 251)",
              }}
            >
              <input
                className="form-control form-control-sm text-center"
                style={{
                  background: "rgb(212, 236, 251)",
                }}
                name="prePerc" // NOS prePerc
                // value={formatGermanFixedBy2(wesFirstValue.nosSumVororderPct)}
                value={formatGermanFixedBy2(
                  templateWesNewPart?.Nos?.[0]?.prePerc
                )}
                // onChange={handleInputChange}
                onChange={(e) => handleInputChange(e, "nos")}
                onBlur={(e) => handleBlurInputChange(e, "nos")}
                // onBlur={handleBlurInputChange}
                autoComplete="off"
              />
            </td>
            <td
              style={{
                background: "rgb(247, 246, 215)",
              }}
              name="nachorder2"
            >
              {/* {inputs.nachorder2} */}
              <input
                className="form-control form-control-sm text-center"
                style={{
                  background: "rgb(247, 246, 215)",
                }}
                name="rePerct" // nos nosNachorderPct
                value={formatGermanFixedBy2(
                  templateWesNewPart?.Nos?.[0]?.rePerct
                )}
                // onChange={handleInputChange}
                // onBlur={handleBlurInputChange}
                onChange={(e) => handleInputChange(e, "nos")}
                onBlur={(e) => handleBlurInputChange(e, "nos")}
                autoComplete="off"
                disabled
              />
            </td>
            <td
              style={{
                border: " 1px solid rgb(212, 236, 251)",
                background: "rgb(212, 236, 251)",
              }}
            >
              <input
                name="percred" //  Nos percred
                className="form-control form-control-sm text-center"
                // value={50}
                // value={formatGermanFixedBy2(wesFirstValue?.nosAbschriftProzentual,)}
                value={formatGermanFixedBy2(
                  templateWesNewPart?.Nos?.[0]?.percred
                )}
                style={{
                  border: " 1px solid rgb(212, 236, 251)",
                  background: "rgb(212, 236, 251)",
                }}
                // onChange={handleWes1Value}
                // onBlur={handleBlurWes1Value}
                onChange={(e) => handleInputChange(e, "nos")}
                onBlur={(e) => handleBlurInputChange(e, "nos")}
                autoComplete="off"
                maxLength={6}
              />
            </td>
            <td
              style={{
                background: "rgb(212, 236, 251)",
              }}
            >
              <input
                name="estimatedCalc" //  Nos estimatedCalc
                className="form-control form-control-sm text-center"
                style={{
                  background: "rgb(212, 236, 251)",
                }}
                // value={"145,0"}
                // value={formatGermanFixedBy2(wesFirstValue?.nosEkAufschlag)}
                value={formatGermanFixedBy2(
                  templateWesNewPart?.Nos?.[0]?.estimatedCalc
                )}
                // onChange={handleWes1Value}
                // onBlur={handleBlurWes1Value}
                onChange={(e) => handleInputChange(e, "nos")}
                onBlur={(e) => handleBlurInputChange(e, "nos")}
                autoComplete="off"
                maxLength={6}
              />
            </td>
            <td
              style={{
                background: "rgb(212, 236, 251)",
              }}
            >
              <input
                name="estimatedCalcDisc" // Nos  estimatedCalcDisc
                className="form-control form-control-sm text-center"
                style={{
                  background: "rgb(212, 236, 251)",
                }}
                // value={"59,2"}
                value={formatGermanFixedBy2(
                  templateWesNewPart?.Nos?.[0]?.estimatedCalcDisc
                )}
                // onChange={handleWes1Value}
                // onBlur={handleBlurWes1Value}
                onChange={(e) => handleInputChange(e, "nos")}
                onBlur={(e) => handleBlurInputChange(e, "nos")}
                autoComplete="off"
                maxLength={6}
              />
            </td>
            {/* new */}
            <td
              style={{
                background: "rgb(247, 246, 215)",
              }}
            >
              <input
                name="outgoingCalc" //  Nos outgoingCalc
                className="form-control form-control-sm text-center"
                style={{
                  background: "rgb(247, 246, 215)",
                }}
                // value={"59"}
                // value={formatGermanFixedBy2(wesFirstValue?.kollektionEkAbschlag)}
                value={formatGermanFixedBy2(
                  templateWesNewPart?.Nos?.[0]?.outgoingCalc
                )}
                autoComplete="off"
                // onChange={handleWes1Value}
                // onBlur={handleBlurWes1Value}
                // onChange={(e) => handleInputChange(e, "nos")}
                // onBlur={(e) => handleBlurInputChange(e, "nos")}
                maxLength={6}
                disabled
              />
            </td>
            <td
              style={{
                background: "rgb(247, 246, 215)",
              }}
            >
              <input
                name="outgoingCalcDisc" //  Nos outgoingCalcDisc
                className="form-control form-control-sm text-center"
                style={{
                  background: "rgb(247, 246, 215)",
                }}
                // value={"60"}
                // value={formatGermanFixedBy2(wesFirstValue?.kollektionEkAbschlag)}
                value={formatGermanFixedBy2(
                  templateWesNewPart?.Nos?.[0]?.outgoingCalcDisc
                )}
                autoComplete="off"
                // onChange={handleWes1Value}
                // onBlur={handleBlurWes1Value}
                // onChange={(e) => handleInputChange(e, "nos")}
                // onBlur={(e) => handleBlurInputChange(e, "nos")}
                maxLength={6}
                disabled
              />
            </td>
            <td
              style={{
                background: "rgb(212, 236, 251)",
              }}
            >
              <input
                name="lugPlan" //  Nos lugPlan
                className="form-control form-control-sm text-center"
                style={{ width: "60px", background: "rgb(212, 236, 251)" }}
                // value={"59"}
                // value={formatGermanFixedBy2(wesFirstValue?.kollektionEkAbschlag)}
                value={formatGermanFixedBy2(
                  templateWesNewPart?.Nos?.[0]?.lugPlan
                )}
                autoComplete="off"
                // onChange={handleWes1Value}
                // onBlur={handleBlurWes1Value}
                onChange={(e) => handleInputChange(e, "nos")}
                onBlur={(e) => handleBlurInputChange(e, "nos")}
                maxLength={6}
              />
            </td>
            <td
              style={{
                background: "rgb(212, 236, 251)",
              }}
            >
              <input
                name="delivQuota" //  Nos delivQuota
                className="form-control form-control-sm text-center"
                style={{
                  background: "rgb(212, 236, 251)",
                }}
                // value={"60"}
                // value={formatGermanFixedBy2(wesFirstValue?.kollektionEkAbschlag)}
                value={formatGermanFixedBy2(
                  templateWesNewPart?.Nos?.[0]?.delivQuota
                )}
                autoComplete="off"
                // onChange={handleWes1Value}
                // onBlur={handleBlurWes1Value}
                onChange={(e) => handleInputChange(e, "nos")}
                onBlur={(e) => handleBlurInputChange(e, "nos")}
                maxLength={6}
              />
            </td>
          </tr>
          {/* Row 3 */}
          <tr className="wes1_gap-row">
            <td colSpan={11}>&nbsp;</td>
          </tr>
          <tr className="wes1_gap-row">
            <td colSpan={11}>&nbsp;</td>
          </tr>
        </tbody>

        <tfoot>
          <tr>
            <td className="total_Wes1">
              <strong></strong>
            </td>
            <td className="total_Wes1">
              <strong>
                {formatGermanFixedBy2(
                  templateWesNewPart?.koll?.[0]?.percValue ||
                    templateWesNewPart?.Nos?.[0]?.percValue
                    ? "100,0"
                    : ""
                )}
              </strong>
            </td>
            <td className="total_Wes1">
              <strong>{formatGermanFixedBy2(VororderTotal || "") || ""}</strong>
            </td>
            <td className="total_Wes1">
              <strong>
                {formatGermanFixedBy2(NachorderTotal || "") || ""}
              </strong>
            </td>
            <td className="total_Wes1">
              <strong>
                {abschriftTotal
                  ? `${formatGermanFixedBy2(abschriftTotal || "")} Ø`
                  : ""}
              </strong>
            </td>
            <td className="total_Wes1">
              <strong>
                {eingangAufschlagTotal
                  ? `${formatGermanFixedBy2(eingangAufschlagTotal || "")} Ø`
                  : ""}
              </strong>
            </td>
            <td className="total_Wes1">
              <strong>
                {eingangAbschlagTotal
                  ? `${formatGermanFixedBy2(eingangAbschlagTotal || "")} Ø`
                  : ""}
              </strong>
            </td>

            {/* new */}

            <td className="total_Wes1">
              <strong>
                {eingAufschlagTotal
                  ? `${formatGermanFixedBy2(eingAufschlagTotal || "")} Ø`
                  : ""}
              </strong>
            </td>
            <td className="total_Wes1">
              <strong>
                {nachEingAbschlagTotal
                  ? `${formatGermanFixedBy2(nachEingAbschlagTotal || "")} Ø`
                  : ""}
              </strong>
            </td>
            <td className="total_Wes1">
              <strong>
                {lugTotal ? `${formatGermanFixedBy2(lugTotal || "")} Ø` : ""}
              </strong>
            </td>
            <td className="total_Wes1">
              <strong>
                {auslieferungsquoteTotal
                  ? `${formatGermanFixedBy2(auslieferungsquoteTotal)} Ø`
                  : ""}
              </strong>
            </td>
          </tr>
        </tfoot>
      </Table>
    </div>
  );
};

export default WesTemplateNew1;
